import CurrencyList from './CurrencyList';

export default CurrencyList;
